import {React, useState, useEffect} from 'react'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";

import { Button, ButtonGroup } from "@chakra-ui/react";
import { useDisclosure } from "@chakra-ui/react";
import {
  FormControl,
  FormLabel,
  FormErrorMessage,
  FormHelperText,
} from "@chakra-ui/react";
import { Input } from "@chakra-ui/react";
import {
  Table,
  Thead,
  Tbody,
  Tfoot,
  Tr,
  Th,
  Td,
  TableCaption,
  TableContainer,
} from "@chakra-ui/react";
import { getAllSubEvents } from '../../../../../services/Api';
import DeleteIcon from "../../../../../images/icons8-delete.svg";
import "./DeleteSubEvent.css"
import { deleteSubEvent } from '../../../../../services/Api';

const DeleteEvent = () => {
    
    const { isOpen, onOpen, onClose } = useDisclosure();
    const [subEvent , setSubEvent] = useState();
    
    useEffect(() => {
        const getSubEvents = async () => {
            const data = await getAllSubEvents();
            console.log(data);
            if(data?.data)
                setSubEvent(data?.data);
            console.log(subEvent);
        }
        getSubEvents();
    }, [])
    
    
    const handleDelete = async (id) => {
        const subEventDelete = await deleteSubEvent(id);
        window.location.reload();
    }
    
  return (
    <>
      <Button onClick={onOpen}>Delete Event</Button>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Event</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <TableContainer>
              <Table variant="striped" colorScheme="teal">
                <Thead>
                  <Tr>
                    <Th>Event ID</Th>
                    <Th>Event Name</Th>
                    <Th></Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {
                    subEvent?.length ? 
                    
                    subEvent?.map((elem) => (
                        <Tr>
                          <td>{elem?.id}</td>
                          <td>{elem?.name}</td>
                          <td>
                            <Button colorScheme="teal" size="xs" onClick={() => (handleDelete(elem.id))}>
                              Delete
                            </Button>
                          </td>
                        </Tr>
                    ))
                    :
                    <tr style={{display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center", width: "inherit"}}>No events to delete</tr>
                  }
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
          <ModalFooter style={{ padding: "2rem" }}>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}

export default DeleteEvent;
